/**
 * Cart Quantity Totals - Updates .totals when quantity changes in .cart-item__quantity-wrapper
 * Handles: plus/minus buttons, quantity input change, delete button
 */

(function () {
  'use strict';

  const CART_FORM = document.getElementById('cart');
  if (!CART_FORM) return;

  const moneyFormat = CART_FORM.dataset.moneyFormat || '{{amount}}';

  const LOADER_STYLES = `
    .cart-qt-loader {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255,255,255,0.8);
      z-index: 5;
    }
    .cart-qt-loader__spinner {
      width: 24px;
      height: 24px;
      border: 2px solid rgba(0,0,0,0.1);
      border-top-color: currentColor;
      border-radius: 50%;
      animation: cart-qt-spin 0.6s linear infinite;
    }
    @keyframes cart-qt-spin {
      to { transform: rotate(360deg); }
    }
  `;

  const loaderStyle = document.createElement('style');
  loaderStyle.textContent = LOADER_STYLES;
  document.head.appendChild(loaderStyle);

  function showLoader(element) {
    const container = element.closest('td.cart-item__quantity') || element.closest('.cart-item__quantity-wrapper');
    if (!container || container.querySelector('.cart-qt-loader')) return;

    container.style.position = 'relative';
    const loader = document.createElement('div');
    loader.className = 'cart-qt-loader';
    loader.innerHTML = '<span class="cart-qt-loader__spinner" aria-hidden="true"></span>';
    loader.setAttribute('aria-label', 'Loading');
    container.appendChild(loader);
  }

  function hideLoader(element) {
    const container = element.closest('td.cart-item__quantity') || element.closest('.cart-item__quantity-wrapper');
    const loader = container?.querySelector('.cart-qt-loader');
    if (loader) loader.remove();
  }

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    const value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, value);
  }

  function updateTotals(cart) {
    const totalsEl = document.querySelector('.totals');
    if (!totalsEl) return;

    const subtotalEl = totalsEl.querySelector('.totals__subtotal-value, .cart__subtotal-price, [data-cart-subtotal]');
    const totalEl = totalsEl.querySelector('.totals__total-value, .cart__total-price, [data-cart-total]');

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }
    if (totalEl) {
      totalEl.textContent = formatMoney(cart.total_price);
    }
  }

  function updateQuantityAndTotals(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line, quantity })
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status) {
          throw new Error(data.description || 'Cart update failed');
        }
        updateTotals(data);
        return data;
      });
  }

  function handleQuantityChange(wrapper) {
    const input = wrapper.querySelector('.quantity__input');
    if (!input || !input.dataset.index) return;

    const line = parseInt(input.dataset.index, 10);
    const quantity = parseInt(input.value, 10) || 0;

    showLoader(wrapper);
    return updateQuantityAndTotals(line, quantity)
      .then((cart) => {
        if (quantity === 0) {
          const row = wrapper.closest('tr');
          if (row) row.remove();
        }
        return cart;
      })
      .finally(() => hideLoader(wrapper));
  }

  function handleQuantityButtonClick(wrapper, button) {
    const input = wrapper.querySelector('.quantity__input');
    if (!input || !input.dataset.index) return;

    const line = parseInt(input.dataset.index, 10);
    const step = parseInt(input.step, 10) || 1;
    const min = parseInt(input.min, 10) || 0;
    const max = input.max ? parseInt(input.max, 10) : null;

    let currentQty = parseInt(input.value, 10) || 0;
    const isPlus = button.getAttribute('name') === 'plus';

    if (!isPlus && currentQty === 1) {
      handleRemoveClick(wrapper)?.catch(() => {});
      return;
    }

    if (isPlus) {
      currentQty += step;
      if (max !== null && currentQty > max) currentQty = max;
    } else {
      currentQty -= step;
      if (currentQty < min) currentQty = min;
    }

    input.value = currentQty;

    showLoader(wrapper);
    return updateQuantityAndTotals(line, currentQty)
      .finally(() => hideLoader(wrapper));
  }

  function handleRemoveClick(wrapper) {
    const removeBtn = wrapper.querySelector('cart-remove-button');
    if (!removeBtn?.dataset.index) return;

    const line = parseInt(removeBtn.dataset.index, 10);

    showLoader(wrapper);
    return updateQuantityAndTotals(line, 0)
      .then(() => {
        const row = wrapper.closest('tr');
        if (row) row.remove();
      })
      .finally(() => hideLoader(wrapper));
  }

  document.addEventListener('click', (e) => {
    const wrapper = e.target.closest('.cart-item__quantity-wrapper');
    if (!wrapper) return;

    const button = e.target.closest('.quantity__button');
    if (button) {
      e.preventDefault();
      e.stopPropagation();
      handleQuantityButtonClick(wrapper, button)?.catch(() => {});
      return;
    }

    const removeLink = e.target.closest('cart-remove-button a');
    if (removeLink) {
      e.preventDefault();
      handleRemoveClick(wrapper)?.catch(() => {});
    }
  }, true);

  document.addEventListener('change', (e) => {
    const input = e.target.closest('.cart-item__quantity-wrapper .quantity__input');
    if (!input) return;

    const wrapper = input.closest('.cart-item__quantity-wrapper');
    if (!wrapper) return;

    handleQuantityChange(wrapper)?.catch(() => {});
  });
})();
